import Layout from "../components/Layout";

export default function NoPage() {
  return (
    <Layout>
      <section className="error-hero">
        <div className="error-visuals" />
        <div className="error-content">
          <img
            src="/assets/images/Tearabyte-Software-Solutions.png"
            alt="Tearabyte Software Solutions"
            className="error-logo"
          />
          <h1>Oops! The page you're looking for isn't here.</h1>
          <p>
            But don't worry! You can go back to our homepage or explore some of our most popular areas:
          </p>
          <ul className="error-links">
            <li><a href="/web">Web Development</a></li>
            <li><a href="/AI">Artificial Intelligence</a></li>
            <li><a href="/dataAnalytics">Data Analytics</a></li>
            <li><a href="/blog">Blog Posts</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
          <p>
            If you think this page should exist, please <a href="/contact" className="conLink">contact us</a> and let us know.
          </p>
        </div>
      </section>
    </Layout>
  );
}
